import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
import log from "cslog";

function MapView({ id, db, device, gs }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    //=========================
    const fixStyle = decodeStyle(ps.fixStyle, gs);

    const style = decodeStyle(ps.style, gs);
    const styleTab = tablet(device) ? decodeStyle(ps.tablet, gs) : {};
    const styleMob = mobile(device) ? decodeStyle(ps.mobile, gs) : {};

    if (isHidden(ps.classes, device)) {
        return null;
    }

    const src = `https://maps.google.com/maps?width=600&height=400&hl=en&q=${input.pinnedLocation}&t=${input.mapMode}&z=${input.zoomLevel}&ie=UTF8&iwloc=B&output=embed`;
    // const width = "100px";
    // const height = "150px";
    const frameBorder = "0";
    const marginHeight = "0";
    const marginWidth = "0";

    const scrolling = "auto";

    return (
        <div
            style={{
                width: "100%",
                height: input.height,
                ...fixStyle,
                ...style,
                "&:hover": decodeStyle(ps.hover, gs),
                ...styleTab,
                ...styleMob,
                overflow: "hidden",
            }}
        >
            <iframe
                title={id}
                width="100%"
                height={input.height || 200}
                frameBorder={frameBorder === undefined ? 0 : `${frameBorder}`}
                scrolling={scrolling === undefined ? "no" : `${scrolling}`}
                marginHeight={
                    marginHeight === undefined ? "0" : `${marginHeight}`
                }
                marginWidth={marginWidth === undefined ? "0" : `${marginWidth}`}
                src={src === undefined ? {} : `${src}`}
            ></iframe>
        </div>
    );
}

export default MapView;
